<script>
export default {
  name: 'ConfirmationDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    btnProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    applyClicked() {
      this.$emit('apply-clicked')
    },
    closeDialog() {
      this.$emit('close-clicked')
    },
  },
}
</script>

<template>
  <v-dialog
    v-model="dialogShow"
    max-width="355">
    <v-card>
      <v-card-title class="headline text-xs-center">
        <v-spacer />
        <slot />
        <v-spacer />
      </v-card-title>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="loading"
          color="secondary"
          @click.native="closeDialog"
        >
          {{ $t('buttons__cancel') }}
        </v-btn>
        <v-btn
          :disabled="loading"
          :loading="loading"
          :color="btnProps.color"
          @click.native="applyClicked"
        >
          {{ btnProps.text }}
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss" module>
@import '@design';
</style>
